import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-12" }
const _hoisted_2 = {
  key: 0,
  class: "flex-1"
}
const _hoisted_3 = { class: "flex flex-1 flex-col w-full" }
const _hoisted_4 = { class: "lg:justify-center items-center mt-3 lg:my-3 flex flex-col lg:flex-none" }
const _hoisted_5 = { class: "flex-1 lg:py-3 lg:py-0" }
const _hoisted_6 = { class: "text-2xl lg:text-3xl" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/2 mx-auto opacity-20 my-1 lg:my-6" }, null, -1)
const _hoisted_8 = { class: "text-xl lg:text-3xl" }
const _hoisted_9 = {
  key: 0,
  class: "pt-6 text-sm"
}
const _hoisted_10 = { class: "flex lg:flex-col pt-3 lg:pt-3 space-x-1 lg:space-x-0 lg:space-y-1" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "pt-6 text-right pr-4 flex space-x-4 justify-end" }

import { CardData } from "@/CardData";
import { isMobileScreen } from "@/screenSize";
import { computed } from "vue";
import Attribution from "./Attribution.vue";
import MyButton from "./MyButton.vue";
import MyCard from "./MyCard.vue";
import SquareImage from "./SquareImage.vue";

interface PracticeBackProps{
  card?: CardData
}

export default /*#__PURE__*/_defineComponent({
  props: {
    card: null
  },
  setup(__props: any) {


const isMobile = computed(()=> isMobileScreen())
const imageSize = computed(()=> {
  if(isMobile.value) return 44
  return 80
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(MyCard, { class: "flex flex-col lg:flex-row space-y-4 lg:space-y-0 lg:space-x-0 lg:space-x-8 items-center" }, {
        default: _withCtx(() => [
          (__props.card?.image)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  _createVNode(SquareImage, {
                    image: __props.card?.image,
                    size: _unref(imageSize),
                    class: "pt-8 lg:pt-0"
                  }, null, 8, ["image", "size"]),
                  (!_unref(isMobile))
                    ? (_openBlock(), _createBlock(Attribution, {
                        key: 0,
                        image: __props.card?.image,
                        class: "mt-4"
                      }, null, 8, ["image"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(__props.card?.front), 1),
                _hoisted_7,
                _createElementVNode("p", _hoisted_8, _toDisplayString(__props.card?.back), 1)
              ])
            ]),
            true
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, "did you remember the meaning?"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(MyButton, {
                background: "palette2",
                class: "flex-1 items-stretch",
                onClickButton: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('easy')))
              }, {
                default: _withCtx(() => [
                  (_unref(isMobile))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, "yes"))
                    : (_openBlock(), _createElementBlock("p", _hoisted_12, "that was easy!"))
                ]),
                _: 1
              }),
              _createVNode(MyButton, {
                background: "warning",
                class: "flex-1",
                onClickButton: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('normal')))
              }, {
                default: _withCtx(() => [
                  (_unref(isMobile))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, "barely"))
                    : (_openBlock(), _createElementBlock("p", _hoisted_14, " difficult but remembered"))
                ]),
                _: 1
              }),
              _createVNode(MyButton, {
                background: "error",
                class: "flex-1",
                onClickButton: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('hard')))
              }, {
                default: _withCtx(() => [
                  (_unref(isMobile))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, "no"))
                    : (_openBlock(), _createElementBlock("p", _hoisted_16, " too difficult"))
                ]),
                _: 1
              })
            ]),
            (_unref(isMobile))
              ? (_openBlock(), _createBlock(Attribution, {
                  key: 1,
                  image: __props.card?.image,
                  class: "mt-4"
                }, null, 8, ["image"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("button", {
        class: "underline",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('edit')))
      }, "edit"),
      _createElementVNode("button", {
        class: "text-error underline",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('delete')))
      }, " delete ")
    ])
  ]))
}
}

})